// Si hay una variable de entorno, la usamos. 
// Si no, y estamos en producción (servido por Apache/Nginx), usamos una ruta vacía para que sea relativa al dominio.
// Solo en desarrollo local (localhost:3000) caemos a localhost:3001.
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : (isLocalhost ? 'http://localhost:3001' : '');

export const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem('authToken');
    return fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${token}`
        }
    });
};
